<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <office-form />
  </v-container>
</template>

<script>
import OfficeForm from './_Form'
export default {
  name: 'AdminTopicEdit',
  components: {
    OfficeForm
  },
  data () {
    return {
      breadcrumbs:[
        { text: 'トピック一覧', disabled: false, to: '/admin/topics', exact: true },
        { text: 'トピック編集', disabled: true, to: '' },
      ]
    }
  },
  created() {},
  methods: {

  }
}
</script>

<style scoped>

</style>
